import axios from 'axios';
import { notifyError } from './pdaFeedback';
import { clearSession, getStoredToken } from './session';

const AUTH_EXPIRED_CODES = new Set(['490000120001', '490000120002']);

// 默认走相对路径,由 nginx 反向代理 /api/ → 后端
// 本地开发可用 REACT_APP_API_BASE 显式指向 http://192.168.0.3:11111/api/v1 等
const request = axios.create({
  baseURL: process.env.REACT_APP_API_BASE || '/api/v1',
  timeout: 10000,
});

function redirectToLogin(message: string) {
  clearSession();
  notifyError(message);
  if (window.location.hash !== '#/login') {
    window.location.hash = '#/login';
  }
}

request.interceptors.request.use((config) => {
  const token = getStoredToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

request.interceptors.response.use(
  (response) => {
    const data = response.data;
    const code = data?.code != null ? String(data.code) : undefined;

    if (!code || code === '0') {
      return data;
    }

    if (AUTH_EXPIRED_CODES.has(code)) {
      redirectToLogin('请重新扫员工卡登录');
    }

    return Promise.reject(data);
  },
  (error) => {
    if (error.response?.status === 401) {
      redirectToLogin('请重新扫员工卡登录');
    }
    return Promise.reject(error.response?.data || error);
  },
);

export default request;
